import React from "react";
import Col from 'react-bootstrap/Col';
import './style.css';

class Slideshow extends React.Component {
    
  constructor(props) {
    super(props);

    this.state = {
      slideIndex: 0
    };

    const ratioWHArray = this.props.ratio.split(":");
    this.ratioWH = ratioWHArray[0] / ratioWHArray[1];
    this.containerRef = React.createRef();
  }

  getNewSlideIndex = (step) => {
    const slideIndex = this.state.slideIndex;
    const numberSlide = this.props.input.length;

    let newSlideIndex = slideIndex + step;

    if (newSlideIndex >= numberSlide) newSlideIndex = 0;
    else if (newSlideIndex < 0) newSlideIndex = numberSlide - 1;

    return newSlideIndex;
  };

  backward = () => {
    this.setState({
      slideIndex: this.getNewSlideIndex(-1)
    });
  };

  forward = () => {
    this.setState({
      slideIndex: this.getNewSlideIndex(1)
    });
  };

  setSlideIndex = (index) => {
    this.setState({
      slideIndex: index
    });
  };

  updateDimensions = () => {
    this.containerRef.style.height = `${
      this.containerRef.offsetWidth / this.ratioWH
    }px`;
  };

  runAutomatic = () => {
    this.setState({
      slideIndex: this.getNewSlideIndex(1)
    });
  };

  componentDidMount() {

    this.updateDimensions();
    window.addEventListener("resize", this.updateDimensions);

    if (this.props.mode === "automatic") {
      const timeout = this.props.timeout || 5000;

      this.automaticInterval = setInterval(
        () => this.runAutomatic(),
        Number.parseInt(timeout)
      );
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions);
    if (this.automaticInterval) clearInterval(this.automaticInterval);
  }
  
  onLinkClick = (url) => {
    window.open(url, '_blank', 'noopener noreferrer');
  };

  render() {
    return (
      <Col xs={12} md={12}>
        <div className="lp-slideshow">
          <div className="acontainer"  ref={node => this.containerRef = node} >
            {this.props.input.map((image, index) => {
              return (
                <div
                  key={index}
                  className={`slide ${
                    this.state.slideIndex === index ? "active" : ""
                  }`}
                >
                  <img className="image" 
                    crossOrigin="anonymous" src={image.src}
                    onClick={() => this.onLinkClick(image.href)}
                    alt={image.caption} 
                  />
                </div>
              );
            })}

            <span className="prev carousel-control-prev-icon" onClick={this.backward}></span>
            <span className="next carousel-control-next-icon" onClick={this.forward}></span>

          </div>

          <div className="dot-container">
            {this.props.input.map((_, index) =>
                <span
                  key={index}
                  className={`dot ${
                    this.state.slideIndex === index ? "active" : ""
                  }`}
                  onClick={() => this.setSlideIndex(index)}
                />
              )
            }
          </div>
        </div>
      </Col>
    );
  }
}

export default Slideshow;